import request from '@/utils/request';

// 示例请求
export function sendSmsCode(data) {
	return request({
		url: '/member/auth/send-sms-codes',
		method: 'post',
		data: data,
	});
}

// 验证码登陆
export function smsLogin(data) {
	return request({
		url: '/member/auth/sms-login',
		method: 'post',
		data: data,
	});
}

// 密码 登陆
export function authLogin(data) {
	return request({
		url: '/member/auth/login',
		method: 'post',
		data: data,
	});
}

//忘记密码
export function updatePasswordBySms(data) {
	return request({
		url: '/member/user/reset-password',
		method: 'put',
		data: data,
	});
}


//原始密码
export function updatePassword(data) {
	return request({
		url: '/member/user/update-password',
		method: 'put',
		data: data,
	});
}

//查询个人信息
export function memberUserGet() {
	return request({
		url: '/member/user/get',
		method: 'get',
	})
}

//热门回收
export function cardHots() {
	return request({
		url: '/card/hots',
		method: 'get',
	})
}

export function noticePub() {
	return request({
		url: '/member/user/notice/pub',
		method: 'get',
	})
}

//服务类目
export function categoryList() {
	return request({
		url: '/card/category/list',
		method: 'get',
	})
}

//卡劵
export function cardList(data) {
	return request({
		url: '/card/list',
		method: 'post',
		data: data,
	})
}

//pdf
export function infraonfigCompany() {
	return request({
		url: '/infra/config/company',
		method: 'get',
	})
}

//企业资质
export function configUserProtocol(data) {
	return request({
		url: '/infra/config/user_protocol',
		method: 'get',
	})
}

//富文本
export function configUserProtocolDAta(data) {
	return request({
		url: '/infra/config/' + data,
		method: 'get',
	})
}

//pdf
export function infrafilepdf(data) {
	return request({
		url: '/infra/file/pdf',
		method: 'post',
		data: data,
	})
}

//隐私协议
export function infraConfigPrivacyProtocol() {
	return request({
		url: '/infra/config/privacy_protocol',
		method: 'get',
	})
}

//常见问题
export function cardListQa() {
	return request({
		url: '/card/list/qa',
		method: 'get'
	})
}

//选择卡类
export function detailsard(data) {
	return request({
		url: '/card/details',
		method: 'get',
		params: data,
	})
}

//充值卡回收pdf
export function infraConfigOrderProtocol() {
	return request({
		url: '/infra/config/order_protocol',
		method: 'get',
	})
}

//常见问题
export function appApiCardListQa() {
	return request({
		url: '/card/list/qa',
		method: 'get',
	})
}

//提交卡劵
export function cardCreate(data) {
	return request({
		url: '/card/create',
		method: 'post',
		data: data,
	})
}


//消息通知
export function cardMessage(data) {
	return request({
		url: '/card/message',
		method: 'get',
		params: data,
	})
}

//消息未读数量
export function cardMessageUnread() {
	return request({
		url: '/card/message/unread',
		method: 'get',
		custom: {
			showLoading: false,
		},
	})
}


//点击已度消息
export function messageRead(data) {
	return request({
		url: '/card/message/read/' + data.id,
		method: 'get',
	})
}

//我的订单
export function cardOrderPage(data) {
	return request({
		url: "/card/order/page",
		method: 'get',
		params: data,
	})
}

//添加账号
export function memberCreate(data) {
	return request({
		url: "/member/account/create",
		method: 'post',
		data: data,
	})
}

//支付宝账号
export function memberAccountList(data) {
	return request({
		url: "/member/account/list",
		method: 'get',
		params: data,
	})
}

//删除账号
export function memberAccountDelete(data) {
	return request({
		url: "/member/account/delete?",
		method: 'post',
		params: data,
	})
}

//立即提现
export function cardPayCreate(data) {
	return request({
		url: "/card/pay/create",
		method: 'post',
		data: data,
	})
}

//提现记录
export function cardPayPage(data) {
	return request({
		url: "/card/pay/page",
		method: 'get',
		params: data,
	})
}

//修改用户名
export function memberUserUpdate(data) {
	return request({
		url: '/member/user/update',
		method: 'PUT',
		data: data,
	})
}

//身份证上传
export function userReaLIdcard(data) {
	return request({
		url: '/member/user/real/idcard',
		method: 'PUT',
		data: data,
	})
}


//人脸识别链接
export function memberUserRealFace() {
	return request({
		url: '/member/user/real/face',
		method: 'get',
	})
}

//订单详情
export function cardOrderDetail(data) {
	return request({
		url: "card/order/detail",
		method: 'get',
		params: data,
	})
}

//我的佣金
export function getProxyOrderList(data) {
	return request({
		url: '/card/order/proxy/list',
		method: 'GET',
		params: data,
		custom: {
			showLoading: false,
		},
	});
}


export function getProxyReport(params) {
	return request({
		url: '/card/proxy/report',
		method: 'GET',
		params,
		custom: {
			showLoading: false,
		},
	});
}

export function queryProxyCustomerReport(params) {
	return request({
		url: '/card/order/proxy/customer/report',
		method: 'GET',
		params,
		custom: {
			showLoading: false,
		},
	});
}


export function queryProxyCustomerList(params) {
	return request({
		url: '/card/order/proxy/customers',
		method: 'GET',
		params,
		custom: {
			showLoading: false,
		},
	});
}


export function refreshToken(refreshToken) {
	return request({
		url: '/member/auth/refresh-token',
		method: 'POST',
		params: {
			refreshToken,
		},
		custom: {
			loading: false, // 不用加载中
			showError: false, // 不展示错误提示
		},
	});
}


export function cardListPost(data) {
	return request({
		url: '/card/list',
		method: 'POST',
		data,
	});
}


export function infraFileUpload(data) {
	return request({
		url: '/infra/file/upload',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data; charset=utf-8'
		},
		data,
	});
}

export function memberUserRealSign(data) {
	return request({
		url: '/member/user/real/sign',
		method: 'PUT',
		data,
	});
}

export function sendConvertData(data) {
	return request({
		url: '/member/user/pc/sendConvertData?params=bd_vid=' + data.bd_vid,
		method: 'get',
	});
}

//提交商户申请 
export function merchantApplyFor(data) {
	return request({
		url: '/merchant/applyFor',
		method: 'post',
		data,
	})
}

//api订单列表
export function merchantOrderPage(params) {
	return request({
		url: '/merchant/order/page',
		method: 'get',
		params,
	})
}

//获取商户详情
export function merchantDetails() {
	return request({
		url: '/merchant/details',
		method: 'get',
	})
}

//获取商户详情
export function merchantCardCategory() {
	return request({
		url: '/merchant/cardCategory',
		method: 'get',
	})
}

//分类下的卡劵
export function merchantCard(params) {
	return request({
		url: '/merchant/card',
		method: 'get',
		params,
	})
}

//卡劵面值列表
export function merchantCardDetail(data) {
	return request({
		url: '/merchant/cardDetail',
		method: 'post',
		data,
	})
}

//补发通知
export function merchantCallbackOrder(data) {
	return request({
		url: '/merchant/callbackOrder',
		method: 'post',
		data,
	})
}

//导出
export function orderExportExcel(params) {
	return request({
		url: '/merchant/export-excel',
		method: 'get',
		responseType: 'blob',
		headers: {
			'Content-Type': 'application/json',
		},
		params,
	})
}

//api统计
export function merchanStatisticsPage(params) {
	return request({
		url: '/merchant/statisticsPage',
		method: 'get',
		params,
	})
}


//账户资金日志
export function merchanRecordPage(params) {
	return request({
		url: '/merchant/recordPage',
		method: 'get',
		params
	})
}

//新闻类型列表
export function cardNewsTypeList() {
	return request({
		url: '/card/news/type/list',
		method: 'get',
	})
}

//新闻标签列表
export function cardNewsTagList() {
	return request({
		url: '/card/news/tag/list',
		method: 'get',
	})
}

//新闻文章分页列表
export function cardNewsArticlePage(params) {
	return request({
		url: '/card/news/article/page',
		method: 'get',
		params
	})
}

//新闻文章详情
export function cardNewsArticleGet(params) {
	return request({
		url: '/card/news/article/get',
		method: 'get',
		params
	})
}

//新闻文章热门浏览
export function cardNewsArticleTopBrowse(params) {
	return request({
		url: '/card/news/article/top-browse',
		method: 'get',
		params
	})
}